import React from "react";
import { Link } from "react-router-dom";
import { Mail, Phone } from "lucide-react";
import Logo from "./Logo";

export default function Footer() {
  return (
    <footer id="contact" className="bg-[#111827] text-white" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div className="md:col-span-2">
            <div className="bg-white inline-block px-3 py-2">
              <Logo />
            </div>
            <p className="mt-6 text-sm leading-relaxed text-white/70 max-w-md">
              Africa&apos;s race photo discovery platform. Built for runners,
              photographers and event organizers across the continent.
            </p>
            <p className="mt-6 text-xs text-white/50 font-mono tracking-wider">
              FIND EVERY MILE. RELIVE EVERY MOMENT.
            </p>
          </div>

          <div>
            <h4 className="font-display text-sm font-semibold mb-4 text-white">Product</h4>
            <ul className="space-y-2 text-sm text-white/70">
              <li><Link to="/" className="hover:text-white transition-colors">Find Photos</Link></li>
              <li><Link to="/login" className="hover:text-white transition-colors">Organizer Sign in</Link></li>
              <li><a href="#how-it-works" className="hover:text-white transition-colors">How it works</a></li>
              <li><a href="#benefits" className="hover:text-white transition-colors">Benefits</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-display text-sm font-semibold mb-4 text-white">Contact</h4>
            <ul className="space-y-3 text-sm text-white/70">
              <li>
                <a
                  href="mailto:events@racesnap.co.bw"
                  className="inline-flex items-center gap-2 hover:text-white transition-colors break-all"
                  data-testid="footer-email-link"
                >
                  <Mail size={14} className="text-[#5B4CFF] shrink-0" />
                  events@racesnap.co.bw
                </a>
              </li>
              <li>
                <a
                  href="tel:+26771835283"
                  className="inline-flex items-center gap-2 hover:text-white transition-colors"
                  data-testid="footer-phone-link"
                >
                  <Phone size={14} className="text-[#5B4CFF] shrink-0" />
                  +267 7183 5283
                </a>
              </li>
              <li className="pt-2 space-y-1">
                <a href="#privacy" className="block hover:text-white transition-colors">Privacy Policy</a>
                <a href="#terms" className="block hover:text-white transition-colors">Terms</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-white/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-3">
          <p className="text-xs text-white/50">© {new Date().getFullYear()} RaceSnap. All rights reserved.</p>
          <p className="text-xs text-white/50 font-mono">Made for African running culture.</p>
        </div>
      </div>
    </footer>
  );
}
